import { Injectable } from "@angular/core";
import { firstValueFrom, Observable, Subject, Subscription } from "rxjs";
import { LocationRelatedAPIService } from "../../shared/services/API/LocationRelatedAPI.service";
import { LocationRelatedDTO } from "../models/LocationRelatedDTO";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { LocationsService } from "./Locations.service";
import { MatDialog } from "@angular/material/dialog";
import { GeneralLocationsDetailsPopUpComponent } from "../components/panel-detail-locations/location-popup-details/general-location-detail-popup/general-location-details-popup.component";
import { LocationDTO } from "../models/LocationDTO";
import { DataNamesDTO } from "../models/DataNamesDTO";
import { IGeoPosDataLocation } from "../../routeMap/models/IDataLocation";
import { CitronellaActionsService } from "../../shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { LocationRelatedTicketPopupComponent } from "../components/panel-detail-locations/location-related/location-related-ticket-popup/location-related-ticket-popup.component";
import { SwalNotificationService } from "../../shared/services/SwalNotification.service";
import { RouteSheetLocationDTO } from "../models/RouteSheetLocationDTO";
import { MapHelperService } from "src/services/map-helper.service";
import { LocationCategoryDTO } from "../models/LocationCategoryDTO";
import { GeneratedLayerService } from "./Generated-Layer.service";
import { NameToSingularPipe } from "../../shared/pipes/NameToSingular.pipe";


@Injectable({
  providedIn: "root",
})
export class RouteSheetUtilService{

  public isLoadingList: boolean = false;

  //para panel related details como popup
  public dialogDetailsRef: any = null;
  locationDTO: LocationDTO;
  keys: string[] = [];
  values: string[] = [];
  keyNames: DataNamesDTO[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];

  location_details_subscription: Subscription;
  location_route_subscription: Subscription;

  constructor(
    private locationService: LocationsService,
    private mapHelperService: MapHelperService,
    private generatedLayerService: GeneratedLayerService,
    private nameToSingularPipe: NameToSingularPipe) {
  }

  setRouteFromFirstLocationToParent(routeSheetLocation: RouteSheetLocationDTO): void {
      this.location_route_subscription = this.locationService.getByIdentifier(routeSheetLocation.identifierChild).subscribe(
        async (data: EstatusJSON) => {
          if (data.isSuccess == true && data.result != null) {
            var routeGeoJson = data.result;
            console.log("related Data", routeGeoJson);
            this.setRouteToPoint(routeGeoJson);
            this.location_route_subscription.unsubscribe();
          }else{
            this.location_route_subscription.unsubscribe();
          }
        }
      );
    }

    async setRouteSheetLayers(routeGeoJson: string, locationGeoJson: string, parentCategory: LocationCategoryDTO, childCategory: LocationCategoryDTO): Promise<void> {
      if (routeGeoJson != null && routeGeoJson != "") {
        const geoJson = JSON.parse(routeGeoJson);
        var parentSingularName = this.nameToSingularPipe.transform(parentCategory.shortName);
        const coordinates = geoJson.features[0].geometry.coordinates;
        
        await this.mapHelperService.AddMapMatchedRoute( "routeSheetRouteSource-"+ childCategory.name, coordinates );
        this.generatedLayerService.createLayer(parentSingularName, "Ruta de " + childCategory.shortName, ["routeSheetRouteSource-"+ childCategory.name, "routeSheetRouteSource-"+ childCategory.name+"-Start", "routeSheetRouteSource-"+ childCategory.name+"-End", "routeSheetRouteSource-"+ childCategory.name+"-Dialog"], true);
        // this.mapHelperService.UpdateLayerGeoJson( "routeSheetRouteSource", geoJson );
        this.mapHelperService.FitBounds( geoJson.features[0].geometry );
      }

      if (locationGeoJson != null && locationGeoJson != "") {
        var parentSingularName = this.nameToSingularPipe.transform(parentCategory.shortName);
        const geoJson = JSON.parse(locationGeoJson);
        this.mapHelperService.UpdateLayerGeoJson("routeSheetLocationsSource-"+ childCategory.name , geoJson);
        
        if (routeGeoJson != null && routeGeoJson  != ""){
          this.moveRouteLayers( "layer-RouteSheetRoute-"+ childCategory.name ,"layer-RouteSheetLocations-" + childCategory.name, true);
          this.mapHelperService.MoveLayer("layer-RouteSheetLocations-"+ childCategory.name + "-PinText", "layer-RouteSheetLocations-"+ childCategory.name);
        }else{
          this.mapHelperService.MoveLayer("layer-RouteSheetLocations-"+ childCategory.name, "layer-location" + childCategory.name + "Active");
          this.mapHelperService.MoveLayer("layer-RouteSheetLocations-"+ childCategory.name, "layer-location" + childCategory.name + "Active");
          this.mapHelperService.MoveLayer("layer-RouteSheetLocations-"+ childCategory.name + "-PinText", "layer-RouteSheetLocations-"+ childCategory.name);
        }
        
        this.generatedLayerService.createLayer(parentSingularName, childCategory.shortName, ["routeSheetLocationsSource-"+ childCategory.name], true);
      }
    }

    setRouteToPoint(routeToPointGeoJson: string): void {
      if (routeToPointGeoJson != null && routeToPointGeoJson != "") {
        this.mapHelperService.UpdateLayerGeoJson( "routeToRouteSheetPointSource", JSON.parse(routeToPointGeoJson) );
        this.mapHelperService.MoveLayer("layer-RouteSheetRouteToPoint", "layer-RouteSheetRoute");
        this.mapHelperService.FitBounds( JSON.parse(routeToPointGeoJson).features[0].geometry );
      }
    }

    clearRouteSheetLayers(parentCategoryName: string): void {
      this.clearRouteSheetLayer(parentCategoryName, "Services", "Servicios");
      this.clearRouteSheetLayer(parentCategoryName, "Unit", "Unidades");
      this.clearRouteSheetLayer(parentCategoryName, "Location", "Ubicaciones");
      this.mapHelperService.clearPopupEvents("images-popup-routeSheet");
    }

    clearRouteSheetLayer(parentCategoryName: string, categoryName: string, categoryShortName: string): void {
      var parentSingularName = this.nameToSingularPipe.transform(parentCategoryName);
      this.mapHelperService.UpdateLayerGeoJson("routeSheetLocationsSource-" + categoryName,  this.mapHelperService.Empty_GeoJson);
      console.log("Deleting layers for category: " + categoryName, "parentSingularName: ", parentSingularName, "categoryShortName: ", categoryShortName);
      
      this.generatedLayerService.deleteLayer(parentSingularName, categoryShortName);

      this.mapHelperService.UpdateLayerGeoJson("routeSheetRouteSource-" + categoryName, this.mapHelperService.Empty_GeoJson);
      this.mapHelperService.UpdateLayerGeoJson("routeSheetRouteSource-" + categoryName + "-Start",  this.mapHelperService.Empty_GeoJson);
      this.mapHelperService.UpdateLayerGeoJson("routeSheetRouteSource-" + categoryName + "-End",  this.mapHelperService.Empty_GeoJson);
      this.mapHelperService.UpdateLayerGeoJson("routeSheetRouteSource-" + categoryName + "-Dialog",  this.mapHelperService.Empty_GeoJson);
      this.generatedLayerService.deleteLayer(parentSingularName, "Ruta de " + categoryShortName);
    }

    clearRouteToPointLayer(): void {
      if (this.location_route_subscription) {
        this.location_route_subscription.unsubscribe();
      }
      this.mapHelperService.UpdateLayerGeoJson("routeToRouteSheetPointSource", this.mapHelperService.Empty_GeoJson);
    }

    moveRouteLayers(routeLayer:string, layerId: string, sendToTop: boolean): void {
      if(sendToTop){
        this.mapHelperService.MoveLayerToTop(layerId);
      }

      this.mapHelperService.MoveLayer(routeLayer + "-background", layerId);
      this.mapHelperService.MoveLayer(routeLayer, layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-arrows", layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-dialog", layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-dialog-text", layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-start-pin-pulse", layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-start-pin", layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-end-pin", layerId);
      this.mapHelperService.MoveLayer(routeLayer + "-label", layerId);
      this.mapHelperService.MoveLayer(layerId, routeLayer + "-dialog");
    }
}
